"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Legal_1 = require("./Legal");
exports.default = Legal_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Legal/index.js
// module id = 1174
// module chunks = 8